import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingContext } from '../../../M_Components';

export const useErrorHandler = () => {
  const loadingCtx = useContext(LoadingContext);
  const { t } = useTranslation();

  const handleHttpError = (error) => {
    const data = error?.response?.data;
    const status = error?.response?.status;
    let messages;
    if (status === 404) {
      messages = [data?.notFound ?? t('NgeServerError')];
    } else {
      const apiErrors = data?.errors?.filter(Boolean);
      messages = apiErrors?.length
        ? apiErrors.map(e => t(`Nge${e}`))
        : [error?.message ?? t('NgeServerError')];
    }
    loadingCtx.toastMessages('error', messages.join(', '), 'Error: ');
    return messages;
  };

  const handleSuccess = (message) => {
    loadingCtx.toastMessages('success', message, 'Success: ');
  };

  return { handleHttpError, handleSuccess };
};
